// extracted by mini-css-extract-plugin
export default {"card":"TEXHC","main":"AcSlM","inner":"i6Qwn","preview":"C23hU","tag":"zIpdG"};